export default "__VITE_ASSET__Ba7s40Jg__"